



































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import DoKoHtmlDialog from "../DoKoHtmlDialog.vue";
import DoKoBtn from "../../controls/DoKoBtn.vue";
import DoKoCardSelectionHtml from "../../controls/DoKoCardSelectionHtml.vue";
import { Action, Getter } from "vuex-class";
import { api as deskApi } from "../../../store/modules/desk";
import { PovertyCards } from "../../../store/modules/desk/types";
import { CARDS, Restriction } from "@dokogd/shared";

@Component({ components: { DoKoHtmlDialog, DoKoBtn, DoKoCardSelectionHtml } })
export default class DoKoRestrictionPoverty extends Vue {
  @Getter(deskApi.getters.getMyCards, { namespace: deskApi.namespace })
  myCards!: CARDS[];

  @Getter(deskApi.getters.getPovertyCards, { namespace: deskApi.namespace })
  povertyCards!: PovertyCards;
  handoverCards: CARDS[] = [];

  @Watch("povertyCards", { immediate: true, deep: true })
  onCardsChange(newPovertyCards: PovertyCards) {
    this.handoverCards = newPovertyCards.trump;
  }

  get disabledCards() {
    return this.povertyCards.trump;
  }

  get selectionRequired() {
    return this.povertyCards.trump.length < this.requiredHandoverCount;
  }

  get requiredHandoverCount() {
    return this.isFoxPoverty ? 4 : 3;
  }

  get cardsToSelect() {
    return this.requiredHandoverCount - this.handoverCards.length;
  }

  get disabled() {
    console.log("CHANGED", this.handoverCards);
    return this.handoverCards.length !== this.requiredHandoverCount;
  }
  get isFoxPoverty() {
    console.log("isFoxPoverty", this.povertyCards);
    return this.povertyCards.isFoxPoverty; //this.cards;
  }

  onConfirm() {
    if (!this.disabled) {
      const restriction: Restriction = {
        type: "poverty",
        cards: this.handoverCards,
        cardsReturned: [],
        wealthyPlayer: null,
      };
      this.$emit("announce-restriction", restriction);
    }
  }
}
